import { useState } from "react";
import { Page, Tabs } from "@shopify/polaris";
import { navigate } from "../../App.js";
import { useBilling } from "../../hooks/useBilling.js";
import { CustomersOverviewPage } from "./Overview.js";
import { AllCustomersPage } from "./AllCustomers.js";
import { RetentionPage } from "./Retention.js";
import { LtvPage } from "./Ltv.js";
import { RfmPage } from "./Rfm.js";
import { Geography } from "../Geography.js";

const ROUTES = [
  "/customers/overview",
  "/customers/all",
  "/customers/retention",
  "/customers/ltv",
  "/customers/rfm",
  "/customers/geography",
];

function getInitialTab(): number {
  const path = window.location.pathname;
  if (path.startsWith("/geography")) return 5; // legacy redirect
  const idx = ROUTES.findIndex((r) => path.startsWith(r));
  return idx >= 0 ? idx : 0;
}

export function CustomersSection() {
  const [selected, setSelected] = useState(getInitialTab);
  const { plan } = useBilling();
  // Treat unresolved plan as Free for the badge — the Pro user will see the
  // badge for ~one frame, but Free users never see geography unbadged.
  const isFree = plan !== "pro" && plan !== "insights";

  const tabs = [
    { id: "overview", content: "Overview", panelID: "overview-panel" },
    { id: "all", content: "All Customers", panelID: "all-panel" },
    { id: "retention", content: "Cohort Retention", panelID: "retention-panel" },
    { id: "ltv", content: "LTV", panelID: "ltv-panel" },
    { id: "rfm", content: "RFM Segments", panelID: "rfm-panel" },
    {
      id: "geography",
      content: "Geography",
      panelID: "geography-panel",
      ...(isFree ? { badge: "Pro" } : {}),
    },
  ];

  function handleTabChange(idx: number) {
    setSelected(idx);
    navigate(ROUTES[idx] ?? "/customers");
  }

  return (
    <Page title="Customers" fullWidth>
      <Tabs tabs={tabs} selected={selected} onSelect={handleTabChange}>
        {selected === 0 && <CustomersOverviewPage />}
        {selected === 1 && <AllCustomersPage />}
        {selected === 2 && <RetentionPage />}
        {selected === 3 && <LtvPage />}
        {selected === 4 && <RfmPage />}
        {selected === 5 && <Geography />}
      </Tabs>
    </Page>
  );
}
